export default {
  ADD_EXHIBITOR: 'Aggiungi espositore',
  NO_EXHIBITOR: 'Non hai ancora nessun espositore aggiunto!',
  EXHIBITOR_NAME: 'Nome espositore',
  EXHIBITOR_EMAIL: 'E-mail espositore',
  EXHIBITOR_CONTACT: 'Contatto espositore',
  CITY: 'Città',
  COUNTRY: 'Paese',
  ADDRESS: 'Indirizzo',
  ORGANISATION: 'Organizzazione',
  TRANSACTION_ID: 'Id di transazione',
  DATE_OF_PURCHASE: 'Data di acquisto',
  DEVICES_COUNT: 'Conteggio dispositivi',
  ADD_EXHIBITOR_SUCCESS: 'Il tuo profilo di espositore è stato impostato con successo!',
  LICENSE_DETAILS: 'Dettagli licenza',
  UPDATE_EXHIBITOR_SUCCESS: 'Il tuo profilo espositore è stato aggiornato con successo!',
  EDIT_EXHIBITOR: 'Modifica espositore'
}
